import RadioSwitcherList from "./RadioSwitcherList";

export default RadioSwitcherList;
